import template from './sw-product-detail-upselling.html.twig';
import './sw-product-detail-upselling.scss';

const {EntityCollection} = Shopware.Data;
const {Component} = Shopware;
const {mapState} = Shopware.Component.getComponentHelper();

Component.register('sw-product-detail-upselling', {
    template,

    inject: ['repositoryFactory'],

    data() {
        return {
            upselling: null,
        }
    },

    metaInfo() {
        return {
            title: 'Upselling',
        }
    },

    computed: {
        ...mapState(
            () => Shopware.Store.get('swProductDetail'),
            [
                'product',
            ],
        ),

        assetFilter() {
            return Shopware.Filter.getByName('asset')
        },

        upsellings() {
            if (!(this.product.extensions && this.product.extensions.zeoProductUpsellings)) {
                if (!this.product.extensions) {
                    this.product.extensions = {}
                }
                this.product.extensions.zeoProductUpsellings = new EntityCollection(null, 'zeo_product_upselling')
            }
            return this.product.extensions.zeoProductUpsellings
        },

        productUpsellingRepository() {
            return this.repositoryFactory.create('zeo_product_upselling')
        },
    },

    methods: {
        onAddUpselling() {
            this.createUpselling()
        },

        createUpselling() {
            const upselling = this.productUpsellingRepository.create(Shopware.Context.api)
            upselling.productId = this.product.id
            upselling.position = this.product.extensions.zeoProductUpsellings.length + 1
            upselling.type = 'productStream'
            upselling.sortBy = 'name'
            upselling.sortDirection = 'ASC'
            upselling.limit = 24
            this.upsellings.push(upselling)
        },
    },
})
